import { type JSX, Suspense, lazy } from "react";

// import only type statically
import type { TreeItemProps } from "@mui/x-tree-view/TreeItem";

const TreeItemLazy = lazy(() => import("./TreeItemLazy"));

export function TreeItemWithSuspense(props: TreeItemProps): JSX.Element {
  return (
    <Suspense>
      <TreeItemLazy {...props} />
    </Suspense>
  );
}
